/* Wholesale order simulator for the home "How pricing works" strip
   (Justin 2026-07-31, v3). Real by-size pricing with the store's real bulk
   tiers (15-49 20% off, 50-99 30%, 100-249 40%, 250+ 50%), applied the way
   the real cart applies them: CUMULATIVELY across every DTF item in the
   cart. Rows with data-flat="Label" are blanks: flat wholesale price, no
   tier, excluded from the cumulative DTF count. The add-item menu reads the
   JSON catalog in the section markup and hides items already in the cart. */
(function () {
  'use strict';

  function money(n) { return '$' + n.toFixed(2); }

  function init(root) {
    var tiers = (root.getAttribute('data-tiers') || '')
      .split(',')
      .map(function (s) { var a = s.split(':'); return { min: parseFloat(a[0]), pct: parseFloat(a[1]) }; })
      .filter(function (t) { return !isNaN(t.min) && !isNaN(t.pct); })
      .sort(function (a, b) { return a.min - b.min; });

    var catalog = [];
    try { catalog = JSON.parse((root.querySelector('[data-sim-catalog]') || {}).textContent || '[]'); } catch (e) {}

    var rowsWrap = root.querySelector('.sim-rows');
    var addWrap = root.querySelector('.sim-addwrap');
    var scrim = document.createElement('div');
    scrim.className = 'sim-scrim';
    document.body.appendChild(scrim);
    var addBtn = root.querySelector('[data-sim-add]');
    var menu = root.querySelector('[data-sim-menu]');
    var rows = [];
    var proto = null;
    var mode = 'usd'; /* 'usd' shows sale price; 'pct' leads with the margin percent */

    /* warm the catalog thumbs so a newly added row never paints the cloned
       row's old image while its own loads */
    catalog.forEach(function (item) {
      if (item.img) { var im = new Image(); im.src = item.img; }
    });

    function pctFor(qty) {
      var pct = 0;
      tiers.forEach(function (t) { if (qty >= t.min) pct = t.pct; });
      return pct;
    }
    /* the real cart tiers on TOTAL DTF quantity, so every DTF row shares one percent */
    function dtfQty() {
      return rows.reduce(function (a, r) { return a + (r.flat ? 0 : r.qty); }, 0);
    }
    function pay(r, pct) {
      if (r.flat) return r.base;
      return Math.round(r.base * 100 * (1 - pct / 100)) / 100;
    }
    function minSale(r, pct) { return Math.ceil(pay(r, pct) / r.step) * r.step; }

    function bindRow(el) {
      var r = {
        el: el,
        name: el.querySelector('[data-name]').textContent,
        base: parseFloat(el.getAttribute('data-base')) || 0,
        step: parseFloat(el.getAttribute('data-step')) || 0.25,
        sale: parseFloat(el.getAttribute('data-sale')) || 0,
        flat: el.getAttribute('data-flat') || '',
        live: el.getAttribute('data-live') || '',
        touched: false,
        qty: 50
      };
      Array.prototype.forEach.call(el.querySelectorAll('[data-q]'), function (b) {
        b.addEventListener('click', function () { r.qty = parseFloat(b.getAttribute('data-q')); render(); });
      });
      Array.prototype.forEach.call(el.querySelectorAll('[data-dir]'), function (b) {
        b.addEventListener('click', function () {
          r.sale = Math.round((r.sale + parseFloat(b.getAttribute('data-dir')) * r.step) * 100) / 100;
          r.touched = true; /* a hand-set price survives the live-pricing refresh */
          render();
        });
      });
      var x = el.querySelector('[data-remove]');
      if (x) x.addEventListener('click', function () {
        rows = rows.filter(function (o) { return o !== r; });
        el.remove();
        render();
      });
      rows.push(r);
      return r;
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-sim-row]'), bindRow);
    if (rows.length) proto = rows[0].el.cloneNode(true);

    /* ---- defaults sit at a 50% margin (Justin 2026-08-03): sale = 2x what you pay at the
       cart's current bulk tier. Only rows the visitor has not hand-priced get refreshed. ---- */
    function applyDefaultSales() {
      var pct = pctFor(dtfQty());
      rows.forEach(function (r) {
        if (r.touched) return;
        r.sale = Math.round(pay(r, r.flat ? 0 : pct) * 2 * 100) / 100;
      });
    }
    applyDefaultSales();

    /* ---- live pricing (Justin 2026-08-03: "prices should always come from the database").
       The embedded numbers are a fallback snapshot; the platform endpoint serves the same
       rows the real order engine prices from. data-live keys map rows to it. ---- */
    (function () {
      if (!window.fetch) return;
      fetch('https://pan32vgek6.execute-api.us-east-1.amazonaws.com/site-pricing')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.ok) return;
          if (Array.isArray(d.tiers) && d.tiers.length) {
            tiers = d.tiers.map(function (t) { return { min: Number(t.minQty), pct: Number(t.pct) }; })
              .filter(function (t) { return !isNaN(t.min) && !isNaN(t.pct); })
              .sort(function (a, b) { return a.min - b.min; });
          }
          function baseFor(live) {
            if (!live) return null;
            var a = live.split(':');
            if (a[0] === 'blank') return (d.blanks || {})[a[1]];
            var fam = (d.transfers || {})[a[0]];
            return fam ? fam[a[1]] : null;
          }
          rows.forEach(function (r) {
            var nb = baseFor(r.live);
            if (nb != null && isFinite(nb)) { r.base = nb; r.el.setAttribute('data-base', nb); }
          });
          catalog.forEach(function (item) {
            var nb = baseFor(item.live);
            if (nb == null || !isFinite(nb)) return;
            item.base = nb;
            item.sale = Math.round((item.flat ? nb : nb * (1 - pctFor(50) / 100)) * 2 * 100) / 100;
          });
          applyDefaultSales();
          render();
        })
        .catch(function () { /* fallback snapshot stays */ });
    })();

    function closeMenu() {
      if (!menu) return;
      menu.classList.remove('is-open');
      scrim.classList.remove('is-open');
      setTimeout(function () {
        menu.hidden = true;
        if (menu.parentElement === document.body && addWrap) addWrap.appendChild(menu);
      }, 280);
      if (addBtn) addBtn.setAttribute('aria-expanded', 'false');
    }
    function openMenu() {
      /* phone sheet portals to <body>: the strip's stacking context (z-index: 0 for the
         beige band) would otherwise trap it under the scrim */
      if (window.matchMedia('(max-width: 640px)').matches && menu.parentElement !== document.body) document.body.appendChild(menu);
      menu.hidden = false;
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
        scrim.classList.add('is-open');
      });
      if (addBtn) addBtn.setAttribute('aria-expanded', 'true');
    }

    function addItem(item) {
      var el = proto.cloneNode(true);
      el.setAttribute('data-base', item.base);
      el.setAttribute('data-sale', item.sale);
      if (item.live) el.setAttribute('data-live', item.live); else el.removeAttribute('data-live');
      if (item.flat) el.setAttribute('data-flat', item.flat); else el.removeAttribute('data-flat');
      el.querySelector('[data-name]').textContent = item.name;
      var img = el.querySelector('.sim-thumb');
      if (img && item.img) img.src = item.img;
      var grp = root.querySelector('[data-group="' + (item.flat ? 'blank' : 'dtf') + '"] [data-group-rows]');
      (grp || rowsWrap).appendChild(el);
      bindRow(el);
      closeMenu();
      render();
      /* phones: the sheet covered the cart, so carry the eye to the new row */
      if (window.matchMedia('(max-width: 640px)').matches) {
        setTimeout(function () { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 320);
      }
    }

    /* menu only offers what the cart does not already hold */
    function buildMenu() {
      if (!menu || !proto) return;
      var list = menu.querySelector('[data-sim-menu-list]') || menu;
      list.innerHTML = '';
      var inCart = rows.map(function (r) { return r.name; });
      var avail = catalog.filter(function (item) { return inCart.indexOf(item.name) === -1; });
      avail.forEach(function (item) {
        var b = document.createElement('button');
        b.type = 'button';
        var bestPct = tiers.length ? tiers[tiers.length - 1].pct : 0;
        var fromPrice = item.flat ? item.base : Math.round(item.base * 100 * (1 - bestPct / 100)) / 100;
        var cat = item.cat || (item.flat ? 'Blank Apparel' : 'DTF Transfers');
        b.innerHTML = '<span class="sim-menu-name">' + item.name.replace(/"/g, '&quot;') + '<span class="sim-menu-cat">' + cat + '</span></span> <span class="sim-menu-from">from ' + money(fromPrice) + ' ea</span>';
        b.addEventListener('click', function () { addItem(item); });
        list.appendChild(b);
      });
      if (addWrap) addWrap.style.display = avail.length ? '' : 'none';
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-mode]'), function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-mode') === 'pct' ? 'pct' : 'usd';
        Array.prototype.forEach.call(root.querySelectorAll('[data-mode]'), function (x) {
          var on = x.getAttribute('data-mode') === mode;
          x.classList.toggle('on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        render();
      });
    });

    if (addBtn && menu && proto) {
      addBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (menu.hidden) openMenu(); else closeMenu();
      });
      scrim.addEventListener('click', closeMenu);
      document.addEventListener('click', function (e) {
        if (!menu.hidden && !menu.contains(e.target)) closeMenu();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
    }

    function render() {
      /* every row the visitor has NOT hand-priced pins to exactly 50% margin - so a row
         added mid-cart, or a tier shift from a qty change, re-defaults sale = 2x cost at
         the cart's CURRENT bulk tier (Justin 2026-08-04) */
      applyDefaultSales();
      var pct = pctFor(dtfQty());
      Array.prototype.forEach.call(root.querySelectorAll('[data-mode-label]'), function (l) {
        l.textContent = mode === 'pct' ? 'Your margin' : 'Your price';
      });
      var units = 0, payTotal = 0, salesTotal = 0;
      rows.forEach(function (r) {
        var p = pay(r, pct);
        if (r.sale < minSale(r, pct)) r.sale = minSale(r, pct);
        var ea = Math.round((r.sale - p) * 100) / 100;
        var profit = ea * r.qty;
        var marginPct = r.sale > 0 ? Math.round((ea / r.sale) * 100) : 0;
        Array.prototype.forEach.call(r.el.querySelectorAll('[data-q]'), function (b) {
          var on = parseFloat(b.getAttribute('data-q')) === r.qty;
          b.classList.toggle('on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        r.el.querySelector('[data-pay]').textContent = money(p);
        var was = r.el.querySelector('[data-was]');
        if (was) {
          var showWas = !r.flat && pct > 0;
          was.hidden = !showWas;
          if (showWas) was.textContent = money(r.base);
        }
        r.el.querySelector('[data-paylbl]').textContent = r.flat ? r.flat : (pct > 0 ? pct + '% off' : 'Wholesale');
        var saleValEl = r.el.querySelector('[data-sale-val]');
        var saleSubEl = r.el.querySelector('[data-sale-sub]');
        if (mode === 'pct') {
          saleValEl.textContent = marginPct + '%';
          if (saleSubEl) { saleSubEl.textContent = money(r.sale) + ' ea'; saleSubEl.hidden = false; }
        } else {
          saleValEl.textContent = money(r.sale);
          if (saleSubEl) { saleSubEl.textContent = marginPct + '% profit'; saleSubEl.hidden = false; }
        }
        r.el.querySelector('[data-profit]').textContent = money(profit);
        r.el.querySelector('[data-ea]').textContent = money(ea) + ' ea';
        var mgnEl = r.el.querySelector('[data-mgn]');
        if (mgnEl) mgnEl.innerHTML = '<b class="sim-pct">' + marginPct + '%</b> margin';
        var down = r.el.querySelector('[data-dir="-1"]');
        if (down) down.disabled = r.sale <= minSale(r, pct) + 1e-9;
        units += r.qty; payTotal += p * r.qty; salesTotal += r.sale * r.qty;
      });
      var unitsEl = root.querySelector('[data-t-units]');
      unitsEl.textContent = 'Qty ' + units;
      unitsEl.setAttribute('data-units', units); /* the phone layout splits label and value via CSS */
      root.querySelector('[data-t-pay]').textContent = money(payTotal);
      root.querySelector('[data-t-sales]').textContent = money(salesTotal);
      root.querySelector('[data-t-keep]').textContent = money(salesTotal - payTotal);
      var tMgn = root.querySelector('[data-t-margin]');
      if (tMgn) tMgn.textContent = (salesTotal > 0 ? Math.round(((salesTotal - payTotal) / salesTotal) * 100) : 0) + '% profit';
      Array.prototype.forEach.call(root.querySelectorAll('.sim-group'), function (g) {
        g.style.display = g.querySelector('[data-sim-row]') ? '' : 'none';
      });
      buildMenu();
    }

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-margin-sim]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
